import req from "@/utils/request";

//  公众号列表
export const wbCountPage = (params) => req.post("/media-service/m/msMedia/wbCountPage", params);

//  公众号列表
export const selectListTree = (params) => req.post("/media-service/m/weiBo/selectListTree", params);
